import { useId } from 'react';

/*
  A label is only a label if it points at something. Prefer the caller's `id`,
  fall back to `name` (unique within a form, and what these pages already pass),
  and only then to a generated one — several fields defaulting to the same
  literal id used to leave every label resolving to the first control.
*/
const useFieldId = (id?: string, name?: string): string => {
  const generatedId = useId();
  return id ?? name ?? generatedId;
};

export default useFieldId;
